import React, { useEffect, useState } from 'react';
import { getApaMetadataLite } from 'services/api/apa/metadata';
import { converter } from 'helpers/converter';
import Button from 'newComponents/Button';
import './Promotions.scss';
import { useSelector } from 'react-redux';
const selectTranslations = store => store.translations;

const Promotions = ({ onClick }) => {
  const [translations, setTranslations] = useState(null);
  const getPromotionsData = () => ({
    __html: converter.convertApaUnicode(
      translations,
      'promo_telmex_telcel_full_text',
      '',
    ),
  });
  const translationsInStore = useSelector(selectTranslations);
  const backButtonKey =
    translationsInStore.promotions_access_option_button_close;

  const getTranslations = async () => {
    const metadataTranslations = await getApaMetadataLite();
    setTranslations(metadataTranslations);
  };

  useEffect(() => {
    getTranslations();
  }, []);

  return (
    <>
      <div className="Promotions">
        <div className="Promotions__Text">
          <div dangerouslySetInnerHTML={getPromotionsData()} />
          <div className="Promotions__Button_Container">
            <Button
              classes={['Promotions__Button']}
              color="red"
              onClick={onClick}
            >
              <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                {backButtonKey}
              </span>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Promotions;
